// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DbMt","fullView":"styles_fullView__29oTX"};